import { falseFn, noop, createMicrotask } from '@solid-primitives/utils';
import { createMemo, untrack, createSignal, batch } from 'solid-js';
import { isServer } from 'solid-js/web';

// src/index.ts
function createUndoHistory(source, options) {
  if (isServer) {
    return {
      canUndo: falseFn,
      canRedo: falseFn,
      undo: noop,
      redo: noop
    };
  }
  let ignoreNext = false;
  const limit = options?.limit ?? 100, sources = Array.isArray(source) ? source.map((s) => createMemo(s)) : [source], clearIgnore = createMicrotask(() => ignoreNext = false), history = createMemo(
    (p) => {
      const setters = [];
      for (const s of sources) {
        const setter = s();
        if (setter)
          setters.push(setter);
      }
      if (ignoreNext || !setters.length) {
        ignoreNext = false;
        return p;
      }
      const count = untrack(p.count[0]), newLength = p.list.length - count, newHistory = p.list.slice(Math.max(0, newLength - limit), newLength);
      newHistory.push(setters);
      return { count: count ? createSignal(0) : p.count, list: newHistory };
    },
    { list: [], count: createSignal(0) }
  ), canUndo = createMemo(() => {
    const h = history();
    return h.list.length - h.count[0]() > 1;
  }), canRedo = createMemo(() => history().count[0]() > 0), move = (n) => {
    ignoreNext = true;
    clearIgnore();
    const h = history(), newCount = h.count[1]((p) => p + n), newIndex = h.list.length - newCount - 1, prevSetters = h.list[newIndex + n], setters = h.list[newIndex];
    for (let i = 0; i < setters.length; i++) {
      if (setters[i] !== prevSetters[i])
        setters[i]();
    }
  };
  return {
    canUndo,
    canRedo,
    undo() {
      untrack(() => canUndo() && batch(() => move(1)));
    },
    redo() {
      untrack(() => canRedo() && batch(() => move(-1)));
    }
  };
}

export { createUndoHistory };
